<template>
  <div id="bar-race" style="width: 100%; height: 100%" />
</template>

<script>
const echarts = require("echarts/index.blank");
require("echarts/lib/component/title");
require("echarts/lib/component/grid");
require("echarts/lib/component/legend");
require("echarts/lib/chart/bar");
require("zrender/lib/svg/svg");
require("echarts/lib/component/graphic");

// import echarts_config from "@/configs/echarts.config";

import { ysFixWebmDuration } from "@/assets/js/fix-webm-duration.js";

export default {
  name: "bar-race",
  props: {
    volume_data: Object,
    title: String,
    data_type: String,
    time_type: String,
    frequency: Number,
    width: Number,
    height: Number,
    is_record: {
      type: Boolean,
      defalut: false,
    },
    mobile_mode: {
      type: Boolean,
      defalut: false,
    },
  },
  data() {
    return {
      // frequency : 300,
    };
  },
  watch: {
    volume_data(new_val) {
      this.volume_data = new_val;
      this.draw();
    },
  },
  mounted() {
    this.draw();
  },
  computed: {},
  methods: {
    draw() {
      if (!this.volume_data.projects) return;

      echarts.init(document.getElementById("bar-race")).dispose();
      var myChart = echarts.init(document.getElementById("bar-race"));
      var option;

      var _this = this;
      var data = [];

      for (let i = 0; i < _this.volume_data.projects.length; ++i) {
        data.push(0);
      }

      var start_time;

      option = {
        title: [
          {
            text: _this.title,
            left: "3%",
            top: "3%",
            textStyle: {
              // fontWeight: 'normal',
              fontSize: _this.mobile_mode ? 20 : 25,
            },
          },
          {
            text: "",
            textAlign: "center",
            left: _this.mobile_mode ? "75%" : "90%",
            bottom: "10%",
            textStyle: {
              fontSize: _this.mobile_mode ? 40 : 50,
              color: "#999999",
            },
          },
          {
            text: "数据来源：盖世汽车研究院",
            right: "3%",
            bottom: "2%",
            textStyle: {
              fontWeight: "normal",
              fontSize: _this.mobile_mode ? 12 : 15,
            },
          },
        ],
        grid: {
          x:
            _this.data_type === "manufacturer" || _this.data_type === "modelline"
              ? "100"
              : "60",
          y: _this.mobile_mode ? "14%" : "17.5%",
          x2: "75",
        },
        xAxis: {
          position: "top",
          max: "dataMax",
          axisLabel: {
            formatter: function (value) {
              // return "";
              return _this.mobile_mode ? "" : value === 0 ? "" : value.toLocaleString();
            },
          },
          axisLine: {
            lineStyle: {
              color: "#999999",
            },
          },
        },
        yAxis: {
          nameLocation: "start",
          name: "单位：（辆）",
          nameTextStyle: {
            padding: [0, 0, -7, -30], // 四个数字分别为上右下左与原位置距离
          },
          type: "category",
          data: _this.volume_data.projects,
          inverse: true,
          animationDuration: 250,
          animationDurationUpdate: 250,
          max: 9,
          axisLabel: {
            formatter: function (params) {
              return params.length > 7 ? params.replace(" ", "\n") : params;
            },
            textStyle: {
              color: "#333333",
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#999999",
            },
          },
        },
        series: [
          {
            realtimeSort: true,
            // name: "X",
            type: "bar",
            data: data,
            itemStyle: {
              normal: {
                color: function (params) {
                  var colorList = [
                    "#4E71F0",
                    "#07C5D3",
                    "#FFCE2C",
                    "#FF812C",
                    "#FA503E",
                    "#EE08AF",
                    "#9927FC",
                    "#1721D1",
                    "#FFA400",
                    "#FFD006",
                    "#8BC34A",
                    "#4CAF51",
                    "#019688",
                    "#3E52B5",
                    "#3D7ADB",
                    "#02AAF4",
                    "#871A84",
                    "#BD0E6A",
                    "#FD634E",
                    "#F7A1AC",
                  ];
                  return colorList[params.dataIndex % colorList.length];
                },
              },
            },
            label: {
              show: true,
              position: "right",
              valueAnimation: true,
              // formatter: function (a) {
              //     return a.data.toLocaleString();
              // }
            },
          },
        ],
        legend: {
          show: false,
        },
        animationDuration: 0,
        animationDurationUpdate: _this.frequency,
        animationEasing: "linear",
        animationEasingUpdate: "linear",
        graphic: [
          {
            type: "image",
            // rotation: Math.PI / 4,//正方形旋转的角度
            style: {
              image: "/images/rank_bg_watermark.png",
            },
          },
          {
            type: "image",
            left: "3%",
            bottom: "2%",
            style: {
              image: "/images/rank_logo_color@2x.png",
              width: _this.mobile_mode ? 100 : 120,
              height: _this.mobile_mode ? 30 : 37,
            },
          },
        ],
        backgroundColor: "#FFFFFF",
      };

      option && myChart.setOption(option);

      window.addEventListener("resize", () => {
        myChart.resize();
      });

      let recorder = {};
      if (_this.is_record) {
        var canvas = document.querySelector("canvas");
        const stream = canvas.captureStream();
        recorder = new MediaRecorder(stream, {
          mimeType: "video/webm;codecs=vp8,opus", // ;codecs=vp8,opus
        });
        const recorderdata = [];
        recorder.ondataavailable = function (event) {
          if (event.data && event.data.size) {
            recorderdata.push(event.data);
          }
        };
        recorder.onstop = () => {
          var duration = new Date().getTime() - start_time;
          var tempblob = new Blob(recorderdata, {
            type: "video/webm;codecs=vp8,opus",
          });
          ysFixWebmDuration(tempblob, duration, function (fixedBlob) {
            tempblob = fixedBlob;
          });
          const url = URL.createObjectURL(
            // new Blob(recorderdata, { type: "video/mp4" }) // ;codecs=vp8,opus
            tempblob
          );
          const a = document.createElement("a");
          a.href = url;
          a.download = _this.title + ".mp4";
          a.click();
        };

        start_time = new Date().getTime();
        recorder.start();
      }

      let interval;
      var data_count = 0;
      function run() {
        if (data_count < _this.volume_data.list.length) {
          data_count++;
        } else {
          clearInterval(interval);
          if (_this.is_record) {
            setTimeout(function () {
              recorder.stop();
            }, 3500);
          }
        }
        var data = option.series[0].data;
        for (let i = 0; i < _this.volume_data.projects.length; ++i) {
          var reuslt = _this.volume_data.list[data_count - 1].filter(
            (item) => item.dataName === _this.volume_data.projects[i]
          )[0];
          if (reuslt) {
            data[i] = reuslt.volume;
            let time_text;
            switch (_this.time_type) {
              case "year":
                time_text = _this.volume_data.dates[data_count - 1].yearDate.toString();
                break;
              case "quarter":
                time_text =
                  _this.volume_data.dates[data_count - 1].yearDate.toString() +
                  "-Q" +
                  _this.volume_data.dates[data_count - 1].quarter.toString();
                break;
              case "month":
                time_text =
                  _this.volume_data.dates[data_count - 1].yearDate.toString() +
                  "-" +
                  _this.volume_data.dates[data_count - 1].monthDate.toString();
                break;
            }
            option.title[1] = {
              text: time_text,
              textAlign: "center",
              left: _this.mobile_mode ? "75%" : "85%",
              bottom: "10%",
              textStyle: {
                fontSize: _this.mobile_mode ? 40 : 50,
                color: "#999999",
                fontWeight: 300,
                // fontWeight:
              },
            };
          }
        }
        myChart.setOption(option);
      }

      setTimeout(function () {
        run();
      }, 0);
      interval = setInterval(function () {
        run();
      }, _this.frequency);
    },
  },
};
</script>
